import React, { useEffect } from 'react';
import { withTweekKeys } from 'react-tweek';
import { usePartner } from 'packages/smart-home-support/partner';
import { setChatExpertise } from 'packages/smart-home-support/utils';
import { PartnerTheme } from '../themes';

export interface ExpertChatConfig {
  appKey: string;
}

export interface ExpertChatProps {
  theme: PartnerTheme;
  expertChatConfig: ExpertChatConfig;
  disabled?: boolean;
}

const initSdk = (props: ExpertChatProps) => () => {
  const { disabled } = props;
  const { appKey } = props.expertChatConfig;

  if (disabled !== true) {
    try {
      window.AE_SDK.initialize(appKey);
    } catch (e) {
      console.error(e);
    }
  }
};

const ExpertChat: React.FC<ExpertChatProps> = (props) => {
  const [partner] = usePartner();
  let propsToUse: ExpertChatProps = props;

  useEffect(initSdk(propsToUse), [props.disabled]);

  useEffect(() => {
    if (partner.chatConfig) {
      setChatExpertise(partner.chatConfig.expertise);
    }
  }, [partner]);

  return <></>;
};

export default withTweekKeys({ expertChatConfig: 'soluto_home_web/chat_expert_sdk/_' })(ExpertChat);



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/ExpertChat.tsx